// 设置模块翻译 - 简体中文
export default {
  title: '设置',
  subtitle: '个性化你的应用体验',
  
  // 设置分组
  groups: {
    privacySecurity: '隐私与安全',
    appSettings: '应用设置',
    personalData: '个人数据',
    helpSupport: '帮助与支持'
  },
  
  // 设置项目
  items: {
    privacySettings: {
      title: '隐私设置与政策',
      subtitle: 'AI功能、数据使用控制'
    },
    privacyCollection: {
      title: '个人资料收集',
      subtitle: '查看我们如何使用您的数据'
    },
    appSettings: {
      title: '应用设置',
      subtitle: '自定义应用行为'
    },
    notificationSettings: {
      title: '通知设置',
      subtitle: '管理推送通知偏好'
    },
    languageSettings: {
      title: '语言设置',
      subtitle: '选择您的首选语言',
      sectionTitle: '选择语言',
      sectionSubtitle: '选择您的首选语言',
      note: '更改语言后将立即生效，无需重启应用'
    },
    bodyDataSetup: {
      title: '身体数据设置',
      subtitle: '配置健康数据参数'
    },
    helpFeedback: {
      title: '帮助与反馈',
      subtitle: '获取帮助或提供建议',
      appTitle: 'CubeMeet',
      appSlogan: '拼出精彩，客聚美好',
      appDescription: '综合性的社交平台，支持多种拼单活动和智能功能。',
      coreFeatures: '核心功能',
      contactSupport: '联系支持',
      emailFeedback: '邮件反馈',
      emailFeedbackDesc: '发送邮件给我们',
      features: {
        travel: { name: '拼游', desc: '旅行智能分账，AI识别收据' },
        carpool: { name: '拼车', desc: '绿色出行，环保拼车' },
        dining: { name: '拼饭', desc: '活动聚餐约会' },
        shopping: { name: '拼购', desc: '二手转让，同城交易' },
        fitness: { name: '拼卡', desc: '身材管理，健康追踪' },
        todo: { name: 'Todo', desc: '任务管理，协同清单' },
        ledger: { name: '拼账', desc: '个人账本与云账本' },
        groupBuying: { name: '团购', desc: '团购订单，拼外卖' },
        toolbox: { name: '工具箱', desc: 'AI智能工具，智能菜谱' }
      }
    }
  },
  
  // 消息
  messages: {
  logoutConfirm: '确定要退出登录吗？',
  deleteAccount: '删除账户',
  deleteAccountConfirm: '删除账户将无法恢复，确定继续吗？',
  deleteAccountNotice: '您的账号将立即被停用并登出。所有数据将于 {date} 从我们的服务器上永久删除。在此期间，您可以联系 support@cubemeet.app 撤销此操作。',
  deleteAccountDisabledToast: '您的账号已被停用。所有数据将于 {date} 被永久删除。如需恢复，请在 {date} 前联系 support@cubemeet.app。',
  settingsSaved: '设置已保存',
  settingsFailed: '设置保存失败'
  },
  
  // 隐私设置屏幕
  privacyScreen: {
    title: '隐私设置与政策',
  infoTitle: '隐私设置与政策',
  infoDescription: '在此您可控制 AI 功能、数据同步与隐私相关设置，保护您的个人信息。',
    privacyProtection: '隐私保护',
    privacyDescription: '我们重视您的隐私，您可以完全控制数据的使用方式。这些设置决定了应用如何处理您的个人信息。',
    aiFeaturesControl: 'AI功能控制',
    aiPrivacyControl: 'AI功能隐私控制',
    aiPrivacySubtitle: '控制AI技术在应用中的使用，保护您的数据隐私',
    enableAiFeatures: '启用AI功能',
    aiFeatureDescription: '包括文字识别、食物识别、智能推荐等AI功能',
    dataUsageSecurity: '数据使用安全',
    dataPrivacyControl: '数据隐私控制',
    dataPrivacySubtitle: '控制数据的云端存储和共享，确保您的隐私安全',
    cloudDataSharing: '数据云端共享',
    cloudSharingDescription: '允许创建共享账本，数据将同步到云端以便与他人协作',
    dataUsageExplanation: '数据使用说明',
    dataUsagePoint1: 'AI处理的数据仅用于提供相应功能',
    dataUsagePoint2: '数据传输采用加密保护',
    dataUsagePoint3: '不会存储您的个人隐私信息',
    dataUsagePoint4: '您可以随时关闭任何功能',
    privacyPolicyAndTerms: '隐私政策与条款',
    privacyPolicy: '隐私政策',
    termsOfService: '服务条款',
    futurePrivacySettings: '更多隐私设置',
    futurePrivacyDescription: '未来版本将添加共享账本、数据同步等更多隐私控制选项'
  },

  // 隐私政策屏幕
  privacyPolicyScreen: {
    title: '隐私政策',
    dataCollection: '数据收集',
    dataCollectionContent: '我们致力于保护您的隐私和个人信息安全。本应用收集的信息仅用于提供更好的服务体验，不会用于其他商业用途。',
    informationUse: '信息使用',
    informationUseContent: '• 您的个人信息仅用于应用功能的正常运行\n• 我们不会向第三方出售或分享您的个人信息\n• 所有数据传输均采用加密保护',
    dataSecurity: '数据安全',
    dataSecurityContent: '我们采用行业标准的安全措施来保护您的个人信息，包括数据加密、安全传输协议等。',
    userRights: '用户权利',
    userRightsContent: '您有权随时：\n• 查看我们收集的关于您的信息\n• 要求更正或删除您的个人信息\n• 撤回对数据处理的同意\n• 随时关闭任何功能或删除账户',
    contactUs: '联系我们',
    contactUsContent: '如果您对本隐私政策有任何疑问，请联系我们：\n邮箱：privacy@cubemeet.com',
    lastUpdated: '最后更新：2025年1月1日'
  },

  // 服务条款屏幕
  termsOfServiceScreen: {
    title: '服务条款',
    acceptanceOfTerms: '接受条款',
    acceptanceContent: '使用本应用即表示您同意遵守以下服务条款。如果您不同意这些条款，请不要使用本应用。',
    serviceDescription: '服务描述',
    serviceDescriptionContent: '拼客是一款社交生活应用，帮助用户：\n• 管理个人和共享账本\n• 组织拼游、拼饭、拼车等活动\n• 与朋友分享生活动态\n• 使用AI智能功能提升体验',
    userResponsibilities: '用户责任',
    userResponsibilitiesContent: '使用本应用时，您同意：\n• 提供准确、真实的信息\n• 不违反法律法规\n• 不侵犯他人权益\n• 不进行恶意行为或滥用服务',
    serviceLimitations: '服务限制',
    serviceLimitationsContent: '我们保留在以下情况下限制或终止服务的权利：\n• 违反服务条款\n• 技术维护需要\n• 法律法规要求\n• 其他合理原因',
    disclaimer: '免责声明',
    disclaimerContent: '本应用按"现状"提供服务，我们不对以下情况承担责任：\n• 服务中断或数据丢失\n• 第三方服务问题\n• 用户间的纠纷\n• 不可抗力因素',
    termsModification: '条款修改',
    termsModificationContent: '我们保留随时修改这些条款的权利。重大变更将通过应用内通知告知用户。继续使用应用即表示您接受修改后的条款。',
    contactUs: '联系我们',
    contactUsContent: '如果您对本服务条款有任何疑问，请联系我们：\n邮箱：my.cubemeet@gmail.com',
    lastUpdated: '最后更新：2025年1月1日'
  }
};
